<template>
  <div class="vv-scale-container">
    <span
      v-for="rangeValue in range"
      :key="rangeValue"
      :class="classes(rangeValue)"
      @click="!disabled ? $emit('change', rangeValue) : undefined"
      >{{ rangeValue }}</span
    >
  </div>
</template>

<script>
export default {
  name: 'VvScale',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    from: Number,
    to: Number,
    value: Number,
    disabled: Boolean
  },
  computed: {
    range() {
      const values = []

      for (let i = this.from; i <= this.to; i++) {
        values.push(i)
      }
      return values
    }
  },
  methods: {
    classes(value) {
      return this.value === value ? 'value selected' : 'value'
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/_variables.scss';

.vv-scale-container {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;

  .value {
    flex-grow: 1;
    box-sizing: border-box;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    box-shadow: 1px 2px 10px 0 rgba(183, 183, 183, 0.5);
    background-color: #ffffff;
    padding: 6px 10px;
    border: 2px solid transparent;
    transition: 200ms;
    cursor: pointer;
  }

  .selected {
    border: 2px solid $primary;
  }
}
</style>
